import React, { useEffect, useCallback } from 'react';
import { copyText } from '../../utils/clipboard';

/**
 * Built-in lightbox for UnifiedTable.
 * Supports two modes:
 * - 'image': shows a full-size image
 * - 'text': shows full cell text with copy button
 */
function TableLightbox({ isOpen, mode, imageUrl, text, onClose }) {
    const handleKeyDown = useCallback(
        (e) => {
            if (e.key === 'Escape') onClose();
        },
        [onClose]
    );

    useEffect(() => {
        if (isOpen) {
            document.addEventListener('keydown', handleKeyDown);
            document.body.style.overflow = 'hidden';
        }
        return () => {
            document.removeEventListener('keydown', handleKeyDown);
            document.body.style.overflow = '';
        };
    }, [isOpen, handleKeyDown]);

    const handleCopyText = useCallback(async () => {
        if (!text) return;
        await copyText(text);
    }, [text]);

    if (!isOpen) return null;

    return (
        <div className="ut-lightbox" onClick={onClose}>
            <div className="ut-lightbox__panel" onClick={(e) => e.stopPropagation()}>
                <button
                    type="button"
                    className="ut-lightbox__close"
                    onClick={onClose}
                    aria-label="Закрыть"
                >
                    &times;
                </button>

                {mode === 'image' && imageUrl && (
                    <img
                        src={imageUrl}
                        alt="preview"
                        className="ut-lightbox__image"
                    />
                )}

                {mode === 'text' && text && (
                    <div className="ut-lightbox__text-wrap">
                        <div className="ut-lightbox__text">{text}</div>
                        <button
                            type="button"
                            className="ut-lightbox__copy"
                            onClick={handleCopyText}
                        >
                            Скопировать
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
}

export default TableLightbox;
